// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__zcwy6","content":"styles_content__SxZg8","text":"styles_text__k8IMW"};